// @ts-nocheck
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './app/design/tokens.css';
import { App } from './app/App.jsx';

const root = document.getElementById('root');
if (!root) throw new Error('Root element is missing');
createRoot(root).render(<React.StrictMode><App/></React.StrictMode>);
